/* import TextField from '@mui/material/TextField'; */
import Grid from '@mui/material/Grid2';
import getStyles from './styles';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
/* import { Button } from '@mui/material'; */

// const fbpageURL =
//   'https://www.facebook.com/share/VutkeKCy9NnqfrL8/?mibextid=wwXIfr';
// const instaPage = ' https://www.instagram.com/beatxfit?igsh=bmZodjhiM3NseDYz';

const ContactUs = (props) => {
  const { sectionRef = null } = props;
  const {
    rootWraper = {},
    sectionTitle = {},
    sectionDiverder = {},
    sectionDescription,
    iconContainer = {},
    innerTitle = {},
    iconSpacing = {},
    adressDetails,
    removeAddressSpacing,
    addFontStyle
    /* basicInput = {} */
  } = getStyles();

  return (
    <Grid ref={sectionRef} id="contactus-section">
      <h2 style={sectionTitle}>Get In Touch</h2>
      <Grid container sx={{ width: '100%', paddingBottom: '40px' }}>
        <Grid
          id="stay-connected-wrapper"
          size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}
          sx={sectionDiverder}
        >
          <p style={innerTitle}>Stay Connected</p>
          <p style={sectionDescription}>
            Follow us on social media to stay up-to-date with the latest news,
            tips, and promotions:
          </p>
          <Grid sx={iconContainer}>
            <a
              style={iconSpacing}
              // href={instaPage}
              // target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ fontSize: 40, color: '#E4405F' }} />
            </a>
            {/* <a href={fbpageURL} target="_blank" rel="noopener noreferrer"> */}
            <a rel="noopener noreferrer">
              <FacebookIcon sx={{ fontSize: 40, color: '#1877F2' }} />
            </a>
          </Grid>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 6, xl: 6, lg: 6 }}>
          <p style={innerTitle}>Contact Us</p>
          <Grid style={{ padding: '10px' }}>
            <Grid size={{ xs: 12 }} sx={rootWraper}>
              <p style={Object.assign({}, adressDetails, addFontStyle)}>
                info@beatxfit.com
              </p>
            </Grid>
            <Grid size={{ xs: 12 }} sx={rootWraper}>
              <p style={adressDetails}> {`044 46070999 /+91 9677771106`} </p>
            </Grid>
            <Grid size={{ xs: 12 }} sx={rootWraper}>
              <p style={Object.assign({}, adressDetails, removeAddressSpacing)}>
                3rd floor Old no 30, new no 49, N Usman Rd,
              </p>
              <p style={Object.assign({}, adressDetails, removeAddressSpacing)}>
                T. Nagar, Chennai,
              </p>
              <p style={Object.assign({}, adressDetails, removeAddressSpacing)}>
                Tamil Nadu 600017
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ContactUs;
